<ng-container *ngIf="note">
    <button type="button" class="release-note-launcher" [class.is-open]="showCard"
        aria-label="Release notes" (click)="toggleCard()">
        <span *ngIf="!showCard" class="release-note-launcher-label">Release notes</span>
        <svg *ngIf="!showCard" class="release-note-launcher-icon" viewBox="0 0 24 24" width="20" height="20" fill="none"
            stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"></path>
            <path d="M14 3v5h5"></path>
            <path d="M8 13h8"></path>
            <path d="M8 17h5"></path>
        </svg>
        <span *ngIf="showCard" class="release-note-launcher-close" aria-hidden="true">&times;</span>
        <span *ngIf="hasUnseen && !showCard" class="release-note-launcher-dot"></span>
    </button>

    <div class="release-note-card" *ngIf="showCard" (click)="openDetail()">
        <button type="button" class="release-note-close" aria-label="Close" (click)="close($event)">&times;</button>
        <div class="release-note-accent">
            <span class="release-note-badge">What's new</span>
        </div>
        <img *ngIf="note.image" [src]="note.image" class="release-note-card-image" alt="" />
        <div class="release-note-card-body">
            <div class="release-note-title">{{ note.title }}</div>
            <div class="release-note-summary">{{ note.summary }}</div>
            <div class="release-note-footer">
                <span>{{ note.date }}</span>
                <span class="release-note-more">Read more</span>
            </div>
        </div>
    </div>

    <div class="release-note-backdrop" *ngIf="showDetail" (click)="close()">
        <div class="release-note-detail" (click)="$event.stopPropagation()">
            <div class="release-note-detail-header">
                <button type="button" class="release-note-close" aria-label="Close" (click)="close()">&times;</button>
                <span class="release-note-badge">What's new</span>
                <h3 class="release-note-detail-title">{{ note.title }}</h3>
                <div class="release-note-meta">
                    <span *ngIf="note.author">{{ note.author }}</span>
                    <span>{{ note.date }}</span>
                </div>
            </div>
            <img *ngIf="note.image" [src]="note.image" class="release-note-detail-image" alt="" />
            <div class="release-note-detail-body">
                <div class="release-note-content" [innerHTML]="note.content"></div>
            </div>
        </div>
    </div>
</ng-container>
